import  React, { useEffect, useState } from 'react'
import { Modal } from '@tnwinc/navex-react'


const messageContent = 'You are no longer signed in. If you would like to continue working, please sign in again. Otherwise you can close your window.'

const handleReload = () => {
    document.location.reload()

}

const isLoggedOut = () => {
    let token = localStorage.getItem('insightsActive')

    return token === null

}


export const LogoutHandler = () => {

    const [showModal, setShowModal] = useState(false)



    return (<Modal id="logoutModal" modalType="BASIC"
        show={showModal}
        message={messageContent}
        okButtonText={"Sign in"}
        onClickedOk={handleReload}
        hideCloseButton
    />)
}